import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HandshakeIcon, TrendingUpIcon, UsersIcon, StarIcon, CheckCircleIcon, PhoneIcon } from 'lucide-react';
export function BecomePartnerPage() {
  const [form, setForm] = useState({
    business: '',
    name: '',
    email: '',
    phone: '',
    type: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  const inputClass = 'w-full px-4 py-3.5 border border-gray-200 bg-white text-black text-sm placeholder-gray-400 focus:outline-none focus:border-[#822433] transition-colors';
  return <div data-id="element-672">
      {/* Hero */}
      <div className="relative py-24 px-4 sm:px-6 lg:px-8 text-center overflow-hidden" style={{
      background: '#000000'
    }} data-id="element-673">
        <img src="https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=1600&q=80" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-20" data-id="element-674" />
        <div className="relative z-10" data-id="element-675">
          <p className="text-xs font-bold uppercase mb-3" style={{
          color: '#CC0000',
          letterSpacing: '0.2em'
        }} data-id="element-676">
            Work With Us
          </p>
          <h1 className="text-4xl sm:text-6xl font-black text-white mb-4" data-id="element-677">
            Become a Partner
          </h1>
          <div className="w-12 h-0.5 mx-auto mb-6" style={{
          background: '#FECB00'
        }} data-id="element-678" />
          <p className="text-gray-400 text-base max-w-xl mx-auto leading-relaxed" data-id="element-679">
            Join the Ameritech Tires network. Grow your business by partnering
            with the DMV's most trusted tire shop.
          </p>
        </div>
      </div>

      {/* Intro */}
      <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-680">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-681">
          <div data-id="element-682">
            <p className="text-xs font-bold uppercase mb-4" style={{
            color: '#CC0000',
            letterSpacing: '0.2em'
          }} data-id="element-683">
              Partnership Opportunity
            </p>
            <h2 className="font-black text-black text-3xl sm:text-4xl leading-tight mb-6" data-id="element-684">
              Grow Together with Ameritech Tires
            </h2>
            <div className="w-10 h-0.5 mb-6" style={{
            background: '#FECB00'
          }} data-id="element-685" />
            <p className="text-base leading-relaxed mb-4" style={{
            color: '#616365'
          }} data-id="element-686">
              Ameritech Tires has served the DMV community for over 30 years.
              We're always looking for like-minded businesses and professionals
              who share our commitment to quality, honesty, and customer
              satisfaction.
            </p>
            <p className="text-base leading-relaxed mb-8" style={{
            color: '#616365'
          }} data-id="element-687">
              Whether you're an auto dealership, insurance company, towing
              service, or local business looking to offer tire services to your
              customers — we'd love to explore how we can work together.
            </p>
            <div className="space-y-3" data-id="element-688">
              {['Referral partnership programs', 'Co-branded service offerings', 'Preferred vendor agreements', 'Revenue sharing opportunities'].map(item => <div key={item} className="flex items-center gap-3" data-id="element-689">
                  <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0" style={{
                background: '#CC0000'
              }} data-id="element-690">
                    <span className="text-white text-xs font-black" data-id="element-691">✓</span>
                  </div>
                  <span className="text-sm font-semibold text-black" data-id="element-692">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
          <div className="overflow-hidden" style={{
          height: '420px'
        }} data-id="element-693">
            <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80" alt="Business partnership" className="w-full h-full object-cover" data-id="element-694" />
          </div>
        </div>
      </section>

      {/* Why Partner */}
      <section className="w-full py-20 px-4 sm:px-6 lg:px-8" style={{
      background: '#111111'
    }} data-id="element-695">
        <div className="max-w-7xl mx-auto" data-id="element-696">
          <div className="text-center mb-14" data-id="element-697">
            <p className="text-xs font-bold uppercase mb-3" style={{
            color: '#CC0000',
            letterSpacing: '0.2em'
          }} data-id="element-698">
              Why Partner With Us
            </p>
            <h2 className="font-black text-white text-3xl sm:text-4xl" data-id="element-699">
              What You Get as a Partner
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-700">
            {[{
            icon: StarIcon,
            title: '30+ Year Reputation',
            body: "Align your brand with the DMV's most trusted tire shop. Our reputation becomes your credibility."
          }, {
            icon: UsersIcon,
            title: 'Thousands of Customers',
            body: 'Gain exposure to our large, loyal customer base across Cottage City, Capitol Heights, and Suitland.'
          }, {
            icon: TrendingUpIcon,
            title: 'Revenue Growth',
            body: 'Earn referral commissions and co-marketing benefits that directly impact your bottom line.'
          }, {
            icon: HandshakeIcon,
            title: 'Dedicated Support',
            body: 'A dedicated partnership manager ensures your experience is smooth, profitable, and long-lasting.'
          }].map(({
            icon: Icon,
            title,
            body
          }) => <div key={title} className="p-8" style={{
            background: '#1a1a1a',
            borderTop: '3px solid #CC0000'
          }} data-id="element-701">
                <div className="w-12 h-12 rounded-full flex items-center justify-center mb-5" style={{
              background: 'rgba(204,0,0,0.20)'
            }} data-id="element-702">
                  <Icon size={20} style={{
                color: '#CC0000'
              }} data-id="element-703" />
                </div>
                <h3 className="font-black text-white text-base mb-3" data-id="element-704">
                  {title}
                </h3>
                <p className="text-sm leading-relaxed" style={{
              color: '#616365'
            }} data-id="element-705">
                  {body}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Application Form */}
      <section className="w-full py-20 px-4 sm:px-6 lg:px-8" style={{
      background: '#F5F5F5'
    }} data-id="element-706">
        <div className="max-w-2xl mx-auto" data-id="element-707">
          <div className="text-center mb-12" data-id="element-708">
            <p className="text-xs font-bold uppercase mb-3" style={{
            color: '#CC0000',
            letterSpacing: '0.2em'
          }} data-id="element-709">
              Apply Now
            </p>
            <h2 className="font-black text-black text-3xl sm:text-4xl mb-3" data-id="element-710">
              Partner Application
            </h2>
            <p className="text-base" style={{
            color: '#616365'
          }} data-id="element-711">
              Tell us about your business and we'll be in touch within 48 hours.
            </p>
          </div>

          {submitted ? <div className="text-center py-16 bg-white p-10" data-id="element-712">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-713">
                <CheckCircleIcon size={32} className="text-green-500" data-id="element-714" />
              </div>
              <h3 className="text-2xl font-black text-black mb-3" data-id="element-715">
                Application Submitted!
              </h3>
              <p className="text-base max-w-sm mx-auto mb-8" style={{
            color: '#616365'
          }} data-id="element-716">
                Thank you for your interest in partnering with Ameritech Tires.
                We'll review your application and reach out within 48 hours.
              </p>
              <Link to="/" className="inline-block text-white font-black text-sm uppercase tracking-widest px-8 py-4 transition-colors duration-200" style={{
            background: '#CC0000'
          }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-717">
                Back to Home
              </Link>
            </div> : <form onSubmit={handleSubmit} className="space-y-4 bg-white p-10" data-id="element-718">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-719">
                <input name="business" value={form.business} onChange={handleChange} placeholder="Business Name *" required className={inputClass} data-id="element-720" />
                <input name="name" value={form.name} onChange={handleChange} placeholder="Your Name *" required className={inputClass} data-id="element-721" />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-722">
                <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="Email Address *" required className={inputClass} data-id="element-723" />
                <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="Phone Number *" required className={inputClass} data-id="element-724" />
              </div>
              <select name="type" value={form.type} onChange={handleChange} required className={inputClass} data-id="element-725">
                <option value="" data-id="element-726">Business Type *</option>
                <option value="auto-dealer" data-id="element-727">Auto Dealership</option>
                <option value="insurance" data-id="element-728">Insurance Company</option>
                <option value="towing" data-id="element-729">Towing Service</option>
                <option value="repair" data-id="element-730">Auto Repair Shop</option>
                <option value="other" data-id="element-731">Other</option>
              </select>
              <textarea name="message" value={form.message} onChange={handleChange} placeholder="Tell us about your business and how you'd like to partner with us..." rows={4} className={inputClass} style={{
            resize: 'none'
          }} data-id="element-732" />
              <button type="submit" className="w-full text-white font-black uppercase tracking-widest py-4 text-sm transition-colors duration-200" style={{
            background: '#CC0000'
          }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-733">
                Submit Application
              </button>
            </form>}
        </div>
      </section>

      {/* CTA */}
      <section className="w-full bg-black py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-734">
        <h2 className="text-2xl sm:text-3xl font-black text-white mb-3" data-id="element-735">
          Questions Before Applying?
        </h2>
        <p className="text-gray-400 text-base mb-8 max-w-lg mx-auto" data-id="element-736">
          Call us directly — we'd love to discuss partnership opportunities with
          you.
        </p>
        <a href="tel:3012549001" className="inline-flex items-center gap-2 text-white font-bold text-base px-8 py-4 transition-colors duration-200" style={{
        background: '#CC0000'
      }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-737">
          <PhoneIcon size={18} data-id="element-738" /> (301) 254-9001
        </a>
      </section>
    </div>;
}